<template>
  <div>
    <div class="cover" @click="searchShow=false" :style="{display:searchShow?'block':'none'}" style="height: 1702px">
      <div class="hidden">
        <div v-if="ads.banner1&&ads.banner1.items" class="top">
          <a :href="ads.banner1.items[0].url" target="_blank">
            <img :src="ads.banner1.items[0].images[0].url">
          </a>
        </div>
        <div v-if="ads.banner2&&ads.banner2.items" class="top">
          <a :href="ads.banner2.items[0].url" target="_blank"> 
            <img :src="ads.banner2.items[0].images[0].url">
          </a>
        </div>
        <div v-if="ads.banner3&&ads.banner3.items" class="top">
          <a :href="ads.banner3.items[0].url" target="_blank">
            <img :src="ads.banner3.items[0].images[0].url">
          </a>
        </div>
      </div>
      <div @click.stop="" class="header" style="border-bottom: none;">

        <div class="main clear" style="background: rgb(255, 255, 255);">
          <!-- 网站logo -->
          <div class="logo">
            <a :href="cityMessage[clientId].herf">
              <img :src="cityMessage[clientId].logo">
            </a>
          </div>
          <div class="searchlist">
            <input type="text" class="searchInput" @keyup.13="doSearch()" v-model="searchKeys" id="keyword" name="keyword" placeholder=""
              value="">
            <img src="/public/w/img/pc/search-03.png" @click="doSearch()" alt="">
            <img src="/public/w/img/pc/close.png" @click="searchKeys=''" class="searchClose" alt="">
          </div>
        </div>
      </div>
    </div>
    <header class="header">
      <!-- <div v-if="clientId == 321300" class="nav-img">
        <img :src="cityMessage[321300].navImg">
      </div> -->
      <div>
        <!-- 吴江顶部广告多图 -->
        <div v-if="ads.banner1&&ads.banner1.items&&clientId == 320598">
          <div class="top" v-for="(item, index) in ads.banner1.items" :key="index">
              <a :href="item.url">
                <img :src="item.images[0].url">
              </a>
            </div>
        </div>
        <div v-else>
          <div v-if="ads.banner1&&ads.banner1.items" class="top">
            <a :href="ads.banner1.items[0].url">
              <img :src="ads.banner1.items[0].images[0].url">
            </a>
          </div>
          <div v-if="ads.banner2&&ads.banner2.items" class="top">
            <a :href="ads.banner2.items[0].url">
              <img :src="ads.banner2.items[0].images[0].url">
            </a>
          </div>
          <div v-if="ads.banner3&&ads.banner3.items" class="top">
            <a :href="ads.banner3.items[0].url">
              <img :src="ads.banner3.items[0].images[0].url">
            </a>
          </div>
        </div>
      </div>
      <div class="header common" style="visibility: visible;">
        <div class="main clear">
          <!-- 网站logo -->
          <div class="logo">
            <a :href="cityMessage[clientId].herf">
              <img :src="cityMessage[clientId].logo">
            </a>
          </div>
          <!-- 网站导航 -->
          <div class="menu">
            <div>
              <li v-for="(item,index) in channels" :class="{on:item.id==showid}" :key="index" v-if="index<channelHideLimit">
                <a v-if="item.id!=showid&&!item.isChain" :href="item.url">{{item.name}}</a>
                <a v-if="item.id==showid&&!item.isChain">{{item.name}}</a>
                <a v-if="item.id!=showid&&item.isChain" target="_blank" :href="item.url">{{item.name}}</a>
                <a v-if="item.id==showid&&item.isChain" target="_blank">{{item.name}}</a>
                <i></i>
              </li>
            </div>
            <li @mousemove='setShow(true)' ref="more" @mouseout='setShow(false)' v-if="channels.length>channelHideLimit" v-bind:class="{ on: isShow }"
              class="only">
              <a>更多</a>
              <span></span>
              <i></i>
            </li>
            <i class="excision"></i>
            <div class="spread" ref="spread" @mousemove='setShow(true)' @mouseout='setShow(false)' v-bind:class="{ on: isShow }">
              <ul class="clear">
                <span v-for="(item,index) in channels" v-if="index>=channelHideLimit">
                  <a v-show="item.id!=showid" :href="item.url" target="_blank">{{item.name}}</a>
                  <a v-show="item.id==showid" class="on" target="_blank">{{item.name}}</a>
                </span>
              </ul>
            </div>

          </div>
          <i class="search" @click="searchShow=true"></i>
          <div id="tp-weather-widget" ref="weather" class="weather"> </div>
          <div class="code">
            <div v-show="cityMessage[clientId].ewm">
              <div class="app">
                <span @mousemove="setQR(true)" @mouseout="setQR(false)">APP下载
                  <span></span>
                </span>
              </div>
              <div class="share" v-bind:style="{display:isQR?'block':'none'}">
                <img src="/public/w/img/410600/app.jpg">
                <p>iphone &amp; Android</p>
                <span>扫一扫下载无限鹤壁APP</span>
              </div>
            </div>
          </div>
          <div class="code">
            <div v-show="cityMessage[clientId].wx">
              <div class="app">
                <span @mousemove="setwxQR(true)" @mouseout="setwxQR(false)">公众号
                  <span></span>
                </span>
              </div>
              <div class="share" v-bind:style="{display:iswxQR?'block':'none'}">
                <img :src="cityMessage[clientId].wx">
                <p></p>
                <span>{{cityMessage[clientId].wxMessage}}</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script src="//widget.seniverse.com/widget/chameleon.js" charset="utf-8" async=""></script>
<style>
  @import "./header.css";
</style>
<script>
  import api from '../../../../asset/news-pc/js/api.js';
  import axios from '../../../../asset/news-pc/js/axios.js';
  export default {
    data() {
      return {
        isShow: false,
        isQR: false,
        iswxQR: false,
        searchKeys: '',
        searchShow: false,
        cityMessage: {
          410600: {
            herf: '//www.hebitv.com',
            message: '扫一扫下载无限鹤壁APP',
            ewm: true,
            wx: false,
            wxMessage: '',
            logo: '/public/w/img/410600/logo_news.png',
            cityId: 'WW372S04V500',
            weather: {
              "flavor": "slim",
              "location": "WW372S04V500",
              "geolocation": "disabled",
              "language": "zh-chs",
              "unit": "c",
              "theme": "chameleon",
              "container": "tp-weather-widget",
              "bubble": "disabled",
              "alarmType": "circle",
              "uid": "U320722CA0",
              "hash": "c68e81537eaadb9743969449b0f8c021"
            },
            cityName: 'hebi'
          }
        }
      }
    },
    props: {
      showid: {
        default: 0
      },
      channels: {
        default: []
      },
      clientId: {
        default: 0
      },
      ads: {
        default: {}
      }
    },
    computed: {
      channelHideLimit() {
        return this.$root.channelHideLimit;
      },
    },
    updated() {

    },
    mounted() {
      if (this.channels.length > this.channelHideLimit) {
        if (this.channelHideLimit !== this.channels.length) {
          const {
            offsetLeft
          } = this.$refs.more;
          this.$refs.spread.style.left = `${offsetLeft-30}px`;
        }
      }
      // (function (T, h, i, n, k, P, a, g, e) {
      //   g = function () {
      //     P = h.createElement(i);
      //     a = h.getElementsByTagName(i)[0];
      //     P.src = k;
      //     P.charset = "utf-8";
      //     P.async = 1;
      //     a.parentNode.insertBefore(P, a)
      //   };
      //   T["ThinkPageWeatherWidgetObject"] = n;
      //   T[n] || (T[n] = function () {
      //     (T[n].q = T[n].q || []).push(arguments)
      //   });
      //   T[n].l = +new Date();
      //   if (T.attachEvent) {
      //     T.attachEvent("onload", g)
      //   } else {
      //     T.addEventListener("load", g, false)
      //   }
      // }(window, document, "script", "tpwidget", "//widget.seniverse.com/widget/chameleon.js"))
      // tpwidget("init", this.cityMessage[this.clientId].weather);
      // tpwidget("show");

      // 天气插件
      let _html = `<iframe style="top: -20px; position: relative;" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=31&h=95&w=80&py=${this.cityMessage[this.clientId].cityName}"></iframe>`
      this.$refs.weather.innerHTML = _html
      /*       // 获取频道
            axios.get(api.channels).then(data => {
              this.channels = data.data.data.items;
            }); */
    },
    methods: {
      doSearch() {
        // 去搜索页面
        const keywords = this.searchKeys.replace(/ /g, '')
        location.href = `${location.origin}/news/searchResult?keywords=${encodeURIComponent(keywords)}`;
      },
      // 控制更多显示
      setShow(bl) {
        this.isShow = bl;
      },
      // 控制二维码显示
      setQR(bl) {
        this.isQR = bl;
      },
      setwxQR(bl) {
        this.iswxQR = bl;
      },
    }
  }
</script>


// WEBPACK FOOTER //
// app/web/component/web/news-layout/header/header.vue